import { MAIL_FOLDERS, MAIL_TABS } from "../../../../constants.js";
import { useMailStore } from "../../../../stores/MailStore.js";
import "react";
import { Icon, Tabs } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
// src/modules/Mail/screens/MailScreen/components/MailSectionTabs/index.tsx
var MailSectionTabs = () => {
	const activeTab = useMailStore((state) => state.activeTab);
	const setActiveTab = useMailStore((state) => state.setActiveTab);
	const setFolder = useMailStore((state) => state.setFolder);
	const setView = useMailStore((state) => state.setView);
	return /* @__PURE__ */ jsx(Tabs, {
		onTabClick: (newView) => {
			setActiveTab(newView);
			setView(newView);
			if (Object.values(MAIL_FOLDERS).includes(newView)) setFolder(newView);
		},
		currentKey: activeTab,
		children: MAIL_TABS.map(({ icon, id, name }) => /* @__PURE__ */ jsx(Tabs.Tab, {
			title: /* @__PURE__ */ jsxs("div", {
				className: "space-x-xs flex items-center",
				children: [/* @__PURE__ */ jsx(Icon, {
					Icon: icon,
					size: "sm"
				}), /* @__PURE__ */ jsx("span", { children: name })]
			}),
			tabKey: id
		}, id))
	});
};
export { MailSectionTabs };

//# sourceMappingURL=index.js.map